export default __webpack_public_path__ + "images/Enteak-Kosei-roof-finial.webp";